/* eslint-disable react/prop-types */
import React from 'react';
import { useLoomValidation } from '../../../hooks/use-loom-validation';

const LOOM_BASE_URL = 'https://www.loom.com';

interface LoomVideoProps {
    videoId: string;
    title: string;
    onError: (error: unknown) => void;
}

const LoomVideo: React.FC<LoomVideoProps> = ({ videoId, title, onError }) => {
    const loomValidationUrl = `${LOOM_BASE_URL}/share/${encodeURIComponent(
        videoId
    )}`;
    const { isLoading, error } = useLoomValidation(loomValidationUrl);

    if (!videoId) {
        onError('Loom video ID is empty');
        return null;
    }

    if (error) {
        // TODO(BWAV-2000): Send analytics
        onError(error);
        return null;
    }

    const embedUrl = `${LOOM_BASE_URL}/embed/${encodeURIComponent(
        videoId
    )}?hide_owner=true`;

    return (
        <div
            className="component-video__container"
            data-testid="loom-video-container"
        >
            {!isLoading && (
                <iframe
                    src={embedUrl}
                    title={title}
                    allow="fullscreen"
                    // fallback for browsers that don't support allow="fullscreen"
                    allowFullScreen
                    // @ts-ignore - this is a workaround for browsers that don't support allowFullScreen
                    mozallowfullscreen="true"
                    webkitallowfullscreen="true"
                    sandbox="allow-same-origin allow-scripts"
                    className="component-video__iframe"
                />
            )}
        </div>
    );
};

export default LoomVideo;
